<template>
  <TheMenuLayout>
    <PublicCGU />
  </TheMenuLayout>
</template>

<script>
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import PublicCGU from '@/views/PublicCGU.vue';

export default {
  name: 'CGU',
  components: {
    TheMenuLayout,
    PublicCGU,
  },
};
</script>
